<div class="app-widget app-widget-orange" (click)="onClick()" >
    <div class="app-widget-left">
        <i class="fa-solid fa-file-edit"></i>
    </div>
    <div class="app-widget-right">
        <div class="app-widget-content">
            <span class="app-widget-title">{{ translationManager.getTranslation('Недостављене понуде') }}</span>
            <div class="app-widget-value">
                <div class="app-widget-spinner" *ngIf="loading">
                    <div class="spinner-border">
                    </div>
                </div>
                <span *ngIf="!loading">{{ value | appvalue}}</span>
            </div>
        </div>
    </div>
</div>
